<div class="bg-grey-10 flex h-screen w-full items-center justify-center">
  <div class="flex h-full w-full rounded-sm md:container md:h-auto lg:w-[790px]">
    <div class="custom-bg-united h-full w-full space-y-5 p-8">
      <div class="flex items-end justify-end">
        <div>
          <img
            src="https://storage.googleapis.com/troyai-public-assets/troy.ai/themes/uhg_logo.svg" />

          <div class="border-grey-20/20 mt-2 border-t pt-2">
            <span class="block text-xs text-white opacity-40">Powered by Troy.AI</span>
          </div>
        </div>
      </div>

      <div>
        <div class="mb-5 space-y-4 p-2 text-sm text-white">
          <p class="block">
            We want to thank you for participating in the CY 2025 United Healthcare’s adherence
            program powered by Troy.AI this year. We received a lot of great feedback and hope
            Troy.AI was a valuable tool for your pharmacy's adherence program.
          </p>

          <p>Here is what to expect as the year winds down:</p>

          <ol class="text-grey-10 space-y-2 pl-6 text-sm">
            <li class="block">
              1. Payment eligibility: Pharmacies will receive payment if PDC(Percentage of days
              covered) for Diabetes, Hypertension, and Hyperlipidemia is >= 90%, as per United
              Healthcare’s guidance.
            </li>
            <li class="block">
              2. Confirmation of eligibility: Adherence is calculated through 12/31/2025 and numbers
              are finalized after 1/15/2026.
            </li>
            <li class="block">
              3. Expect notification of eligibility and payment information before the end of
              February, 2026.
            </li>
            <li class="block">
              4. Pharmacies eligible for payment will receive the communicated amount before the end
              of April, 2026.
            </li>

            <li class="block">
              5. We will alert you of your eligibility to participate in the program in the future
              based on United Healthcare direction.
            </li>
          </ol>

          <p>
            Thank you again for your contribution to our program. If you have any questions or
            feedback for us, please email us at
            <a href="mailto:united@troy.ai">united@troy.ai</a> or call 910-460-0553.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
